export default {
    getItem (sKey) {
        if (!sKey) {
            return null
        }
        return decodeURIComponent(document.cookie.replace(new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')) ||
            window.localStorage.getItem(sKey) || window.sessionStorage.getItem(sKey) || null
    },
    setItem (sKey, sValue, opts = {}) {
        let sExpires = ''
        if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
            return false
        }
        if (opts.vEnd) {
            switch (opts.vEnd.constructor) {
                case Number:
                    sExpires = opts.vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${opts.vEnd}`
                    break
                case String:
                    sExpires = `; expires=${opts.vEnd}`
                    break
                case Date:
                    sExpires = `; expires=${opts.vEnd.toGMTString()}`
                    break
            }
        }
        document.cookie = `${encodeURIComponent(sKey)}=${encodeURIComponent(sValue)}${sExpires}${opts.sDomain ? `; domain=${opts.sDomain}` : ''}${opts.sPath ? `; path=${opts.sPath}` : ''}${opts.bSecure ? '; secure' : ''}`
        return true
    },
    removeItem (sKey, sPath, sDomain) {
        if (!this.hasItem(sKey)) { return false }
        document.cookie = `${encodeURIComponent(sKey)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${sDomain ? `; domain=${sDomain}` : ''}${sPath ? `; path=${sPath}` : ''}`
        return true
    },
    hasItem (sKey) {
        if (!sKey) {
            return false
        }
        return (new RegExp(`(?:^|;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=`)).test(document.cookie)
    },
    clearItems () {
        let cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i]
            let eqPos = cookie.indexOf('=')
            let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
        }
    }
}
